// source: src/common/template/presentation/presentation.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var src_common_gml_gml_pb = require('../../../../src/common/gml/gml_pb.js');
goog.object.extend(proto, src_common_gml_gml_pb);
goog.exportSymbol('proto.loupe.common.template.presentation.Presentation', null, global);
goog.exportSymbol('proto.loupe.common.template.presentation.PresentationType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.template.presentation.Presentation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loupe.common.template.presentation.Presentation.repeatedFields_, null);
};
goog.inherits(proto.loupe.common.template.presentation.Presentation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.template.presentation.Presentation.displayName = 'proto.loupe.common.template.presentation.Presentation';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loupe.common.template.presentation.Presentation.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.template.presentation.Presentation.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.template.presentation.Presentation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.template.presentation.Presentation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.template.presentation.Presentation.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    ref: jspb.Message.getFieldWithDefault(msg, 2, ""),
    raw: jspb.Message.getFieldWithDefault(msg, 3, ""),
    parsed: (f = msg.getParsed()) && src_common_gml_gml_pb.GML.toObject(includeInstance, f),
    resolved: (f = msg.getResolved()) && src_common_gml_gml_pb.GML.toObject(includeInstance, f),
    errorMessagesList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.template.presentation.Presentation}
 */
proto.loupe.common.template.presentation.Presentation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.template.presentation.Presentation;
  return proto.loupe.common.template.presentation.Presentation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.template.presentation.Presentation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.template.presentation.Presentation}
 */
proto.loupe.common.template.presentation.Presentation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.loupe.common.template.presentation.PresentationType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRef(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRaw(value);
      break;
    case 4:
      var value = new src_common_gml_gml_pb.GML;
      reader.readMessage(value,src_common_gml_gml_pb.GML.deserializeBinaryFromReader);
      msg.setParsed(value);
      break;
    case 5:
      var value = new src_common_gml_gml_pb.GML;
      reader.readMessage(value,src_common_gml_gml_pb.GML.deserializeBinaryFromReader);
      msg.setResolved(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addErrorMessages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.template.presentation.Presentation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.template.presentation.Presentation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.template.presentation.Presentation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.template.presentation.Presentation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getRef();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRaw();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getParsed();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      src_common_gml_gml_pb.GML.serializeBinaryToWriter
    );
  }
  f = message.getResolved();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      src_common_gml_gml_pb.GML.serializeBinaryToWriter
    );
  }
  f = message.getErrorMessagesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
};


/**
 * optional PresentationType type = 1;
 * @return {!proto.loupe.common.template.presentation.PresentationType}
 */
proto.loupe.common.template.presentation.Presentation.prototype.getType = function() {
  return /** @type {!proto.loupe.common.template.presentation.PresentationType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.loupe.common.template.presentation.PresentationType} value
 * @return {!proto.loupe.common.template.presentation.Presentation} returns this
 */
proto.loupe.common.template.presentation.Presentation.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string ref = 2;
 * @return {string}
 */
proto.loupe.common.template.presentation.Presentation.prototype.getRef = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.template.presentation.Presentation} returns this
 */
proto.loupe.common.template.presentation.Presentation.prototype.setRef = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string raw = 3;
 * @return {string}
 */
proto.loupe.common.template.presentation.Presentation.prototype.getRaw = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.template.presentation.Presentation} returns this
 */
proto.loupe.common.template.presentation.Presentation.prototype.setRaw = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional loupe.common.gml.GML parsed = 4;
 * @return {?proto.loupe.common.gml.GML}
 */
proto.loupe.common.template.presentation.Presentation.prototype.getParsed = function() {
  return /** @type{?proto.loupe.common.gml.GML} */ (
    jspb.Message.getWrapperField(this, src_common_gml_gml_pb.GML, 4));
};


/**
 * @param {?proto.loupe.common.gml.GML|undefined} value
 * @return {!proto.loupe.common.template.presentation.Presentation} returns this
*/
proto.loupe.common.template.presentation.Presentation.prototype.setParsed = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.template.presentation.Presentation} returns this
 */
proto.loupe.common.template.presentation.Presentation.prototype.clearParsed = function() {
  return this.setParsed(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.template.presentation.Presentation.prototype.hasParsed = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional loupe.common.gml.GML resolved = 5;
 * @return {?proto.loupe.common.gml.GML}
 */
proto.loupe.common.template.presentation.Presentation.prototype.getResolved = function() {
  return /** @type{?proto.loupe.common.gml.GML} */ (
    jspb.Message.getWrapperField(this, src_common_gml_gml_pb.GML, 5));
};


/**
 * @param {?proto.loupe.common.gml.GML|undefined} value
 * @return {!proto.loupe.common.template.presentation.Presentation} returns this
*/
proto.loupe.common.template.presentation.Presentation.prototype.setResolved = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.template.presentation.Presentation} returns this
 */
proto.loupe.common.template.presentation.Presentation.prototype.clearResolved = function() {
  return this.setResolved(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.template.presentation.Presentation.prototype.hasResolved = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated string error_messages = 6;
 * @return {!Array<string>}
 */
proto.loupe.common.template.presentation.Presentation.prototype.getErrorMessagesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.loupe.common.template.presentation.Presentation} returns this
 */
proto.loupe.common.template.presentation.Presentation.prototype.setErrorMessagesList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.template.presentation.Presentation} returns this
 */
proto.loupe.common.template.presentation.Presentation.prototype.addErrorMessages = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.template.presentation.Presentation} returns this
 */
proto.loupe.common.template.presentation.Presentation.prototype.clearErrorMessagesList = function() {
  return this.setErrorMessagesList([]);
};


/**
 * @enum {number}
 */
proto.loupe.common.template.presentation.PresentationType = {
  GML: 0
};

goog.object.extend(exports, proto.loupe.common.template.presentation);
